@if (initialized) {
  <form [formGroup]="form">
    <rask-page [pageTitle]="title">
      <ng-container header>
        <rask-action-button
          [disabled]="!canDelete"
          (click)="delete()"
          icon="far fa-trash-alt"
          aid="delete">
          {{commonTexts.delete}}
        </rask-action-button>
        <rask-action-button
          [disabled]="!canShowLog"
          (click)="showLog()"
          icon="fas fa-history"
          aid="showLog">
          {{texts.visaLogg}}
        </rask-action-button>
        <div class="btn-group" ngbDropdown role="group">
          <button class="btn" [disabled]="!canCopy" ngbDropdownToggle aid="copy">{{texts.copy.title}}</button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <a ngbDropdownItem href="javascript: void(0)" (click)="copyProdukt(true)" aid="copyProduktWithSpec">{{texts.copy.produktWithSpec}}</a>
            <a ngbDropdownItem href="javascript: void(0)" (click)="copyProdukt(false)" aid="copyProduktWithoutSpec">{{texts.copy.produktWithoutSpec}}</a>
            <a ngbDropdownItem href="javascript: void(0)" (click)="copyProduktspecifikation()" aid="copySpecifikation">{{texts.copy.specifikation}}</a>
          </div>
        </div>
      </ng-container>
      @if (produkt) {
        <rask-produkt-detail-header
          [formMode]="formMode"
          [rootForm]="form"
          [produkt]="produkt"
          [produktBasdata]="produktBasdata">
        </rask-produkt-detail-header>
      }
      @if (produktspecifikation) {
        <rask-produkt-detail-produktspecifikation
          [formMode]="formMode"
          [rootForm]="form"
          [produkt]="produkt"
          [produktspecifikation]="produktspecifikation"
          [onProduktspecifikationChanged]="onProduktspecifikationChanged">
        </rask-produkt-detail-produktspecifikation>
      }
      @if (displayProduktspecifikationTabs) {
        <rask-container-block>
          @if (form && produktspecifikation) {
            <rask-tabs parameterName="tab" aid="produktspecifikation" layout="child" [isQueryParam]="false">
              <rask-tab [label]="texts.tabBasdata" [routeId]="tabNames.basdata" aid="tabBasdata">
                <rask-produkt-detail-bas
                  [rootForm]="form"
                  [produkt]="produkt"
                  [produktspecifikation]="produktspecifikation">
                </rask-produkt-detail-bas>
              </rask-tab>
              @if (displayFordelningsmatristab) {
                <rask-tab [label]="texts.tabFordelningsmatris" [routeId]="tabNames.fordelningsmatris"
                  (onTabSelected)="openFordelningsmatrisTab()" aid="tabFordelningsmatris">
                  @if (fordelningsmatrisTabOpen) {
                    <rask-produkt-detail-fordelningsmatris
                      [rootForm]="form"
                      [produktspecifikation]="produktspecifikation">
                    </rask-produkt-detail-fordelningsmatris>
                  }
                </rask-tab>
              }
              <rask-tab [label]="texts.tabUppfoljning" [routeId]="tabNames.uppfoljning" aid="tabUppfoljning">
                <rask-produkt-detail-uppfoljning
                  [rootForm]="form"
                  [produkt]="produkt"
                  [produktspecifikation]="produktspecifikation">
                </rask-produkt-detail-uppfoljning>
              </rask-tab>
              <rask-tab [label]="texts.tabProduktinstruktioner" [routeId]="tabNames.produktinstruktioner" aid="tabProduktinstruktioner">
                <rask-produkt-detail-produktinstruktioner
                  [rootForm]="form"
                  [produktspecifikation]="produktspecifikation">
                </rask-produkt-detail-produktinstruktioner>
              </rask-tab>
            </rask-tabs>
          }
        </rask-container-block>
      }
      <ng-container footerContent>
        <rask-save-button [disabled]="!canSave" (click)="save()" aid="save"></rask-save-button>
      </ng-container>
    </rask-page>
  </form>
}
